export const setSystemDictionary = (state, payload) => {
  state.systemDictionaries = payload;
};
